// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"c890b2d0","133":"1f280199","191":"ed1f4d3a","453":"1e1533c4","488":"6c55fa77","541":"f55d6358","615":"72ede347","703":"df6795a0","766":"599e546b","922":"10fb60f2","989":"67cf753b"}[chunkId] + ".chunk.js";
};